import React, { useLayoutEffect, useRef, useState } from 'react';
import { ArkoBackgroundAnalysisChip } from './ArkoBackgroundAnalysisChip';
import { useOptionalPortalBackgroundJobs } from './portalBackgroundJobsContext';
import type { PortalView } from './portalNavigation';

/**
 * Klasse PORTAL_GLOCKE_EREIGNIS.
 * Das Analysefenster hängt nicht daran, dass der Chat schon offen ist.
 * Liegt die Chatfläche schon da, bleibt das bestehende Fenster dort.
 */
export const PortalGlockeAnalysisHost: React.FC<{ view: PortalView }> = ({ view }) => {
  const jobs = useOptionalPortalBackgroundJobs();
  const hostRef = useRef<HTMLDivElement | null>(null);
  const openId = jobs?.openJobId ?? null;
  const job = jobs?.analysisViews.find((row) => row.request_id === openId) ?? null;
  const likelyHasPane = view === 'chat' || view === 'akten' || view === 'diktat' || view === 'document_editor';
  const [standDown, setStandDown] = useState(likelyHasPane);

  useLayoutEffect(() => {
    if (!job) {
      setStandDown(false);
      return;
    }
    const panes = document.querySelectorAll('.portal-arko-pane');
    const foreign = Array.from(panes).some((node) => !hostRef.current?.contains(node));
    setStandDown(foreign);
  }, [job, view]);

  if (!jobs || !job || standDown || view === 'dokumente') return null;

  return (
    <div
      ref={hostRef}
      className="portal-arko-pane fixed inset-0 z-[80]"
      data-testid="portal-glocke-analyse-host"
    >
      <ArkoBackgroundAnalysisChip
        job={job}
        open
        onOpenChange={(next) => jobs.setOpenJobId(next ? job.request_id : null)}
        onCancel={jobs.cancelJob}
        onDismiss={jobs.dismissFinished}
      />
    </div>
  );
};
